import React from 'react';

import {
    Group, Space, Stack,
} from '@mantine/core';

import DataTable from './DataTable';
import DataTableCreate from './DataTableCreate';
import DataTablePaging from './DataTablePaging';
import DataTableSearch from './DataTableSearch';
import useDataFetch from './hooks/useDataFetch';
import useDataOrdering from './hooks/useDataOrdering';
import useVideoSchema from './schemas/useVideoSchema';
import { PROJECT_PREFIX } from '../../const';
import {
    getVideoList, removeVideo,
} from '../../utils/neurons';

export default function VideoDataTable({ type }) {
    const id = `list-${type}`;

    const { ordering, setOrdering } = useDataOrdering();

    const {
        data,
        mutatation,
        params,
        setParams,
        refreshData,
        ...restProps
    } = useDataFetch({
        id,
        fetchFn: getVideoList,
    });

    const { page, limit, search } = params;

    function scrollTop() {
        const scrollContainer = document.getElementsByClassName('main-wrapper')[0];
        scrollContainer.scrollTop = 0;
    }

    function handleSearch(e) {
        const { value } = e.currentTarget;

        setParams({
            search: value,
        });
    }

    function clearSearch() {
        setParams({
            search: '',
        });
    }

    function handleItemDelete(itemId) {
        mutatation.mutate({
            mutationFn: removeVideo,
            mutationProps: { id: itemId },
        });
    }

    function handlePageChange(newPage) {
        setParams({
            page: newPage,
        });

        scrollTop();
    }

    function handleLimitChange(newLimit) {
        setParams({
            limit: +newLimit,
        });
    }

    const schema = useVideoSchema({ type, onDelete: handleItemDelete });

    return (
        <>
            <Stack spacing="xs">
                <DataTableCreate
                    newStoryLink={`${PROJECT_PREFIX}/video/new/`}
                    onRefresh={refreshData}
                />
                <Group>
                    <DataTableSearch
                        search={search}
                        onSearch={handleSearch}
                        onSearchClear={clearSearch}
                    />
                </Group>
            </Stack>
            <Space h="lg" />
            <Space h="4px" />
            <DataTable
                {...restProps}
                ordering={ordering}
                onOrdering={setOrdering}
                schema={schema}
                data={data}
            />
            <Space h="md" />
            <DataTablePaging
                page={page}
                total={data?.total_pages}
                limit={limit}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </>
    );
}
